
































































































































import Vue from "vue";
import ADD_PARTICIPANT_MUTATION from "@/graphql/AddParticipantMutation.gql";
import GROUP_QUERY from "@/graphql/GroupQuery.gql";
import { AuthRepository } from "@ct/auth";
import { AlertBar } from "@ct/alert";
import { GroupQuery_group, GroupQuery_group_sessions } from "@/graphql/generatedTypes/GroupQuery";
import {
  AddParticipantMutation,
  AddParticipantMutationVariables
} from "@/graphql/generatedTypes/AddParticipantMutation";
import { RoleEnum } from "@/graphql/generatedTypes/globalTypes";
import formatUtils from "@/components/FormatUtil";
import UserAvatar from "@/views/UserAvatar.vue";
import _ from "lodash";
import GroupDateTime from "@/components/GroupDateTime.vue";
import GroupSessionTime from "@/components/GroupSessionTime.vue";
import ReadMore from "@/components/ReadMore.vue";
import moment from "moment";

export default Vue.extend({
  name: "GroupsShow",
  metaInfo: {
    title: "Intro To IMS",
    meta: [
      {
        name: "description",
        content:
          "Your results are waiting! Register for your complimentary training course and access the Discover Your Inner Matrix training materials."
      },
      {
        property: "og:title",
        content: "Intro To IMS"
      },
      {
        property: "og:description",
        content:
          "Your results are waiting! Register for your complimentary training course and access the Discover Your Inner Matrix training materials."
      },
      {
        property: "og:image",
        content: "https://res.cloudinary.com/dm1xkelzx/image/upload/q_auto/v1686607172/IMS_Triangle_hcfwcc.png"
      }
    ]
  },
  components: { AlertBar, UserAvatar, GroupDateTime, GroupSessionTime, ReadMore },
  apollo: {
    group: {
      query: GROUP_QUERY,
      variables(): { id: string } {
        return {
          id: this.groupID
        };
      }
    }
  },
  data() {
    return {
      groupID: this.$route.params.id,
      group: {
        sessions: [] as GroupQuery_group_sessions[]
      } as GroupQuery_group,
      currentUser: this.$authRepository.getCurrentUser(),
      isLoaded: false
    };
  },
  computed: {
    canEditGroup(): boolean {
      return (
        AuthRepository.getCurrentUser()?.canEdit(RoleEnum.ADMIN) ||
        AuthRepository.getCurrentUser()?.email === this.group?.trainer?.email
      );
    },
    inGroup(): boolean {
      return this.group?.participants?.some(
        (participant: { email: string }) => participant.email === AuthRepository.getCurrentUser()?.email
      );
    },
    secondSessionHasPassed(): boolean {
      const focusingMindSession = this.group.sessions.find(session => session.name == "Focusing the Mind");
      if (!focusingMindSession) return false;

      const dateTimeOfSecondSession = `${focusingMindSession.date} ${formatUtils.timeOnly(
        focusingMindSession.time ? focusingMindSession.time : ""
      )}`;
      return moment().isAfter(dateTimeOfSecondSession);
    }
  },
  mounted() {
    if (this.$route?.query?.join === "true") {
      this.isLoaded = true;
      setTimeout(this.joinGroup, 5000);
    }
  },
  methods: {
    ...formatUtils,
    async joinGroup() {
      const currentUser = AuthRepository.getCurrentUser();
      if (currentUser === null) {
        await this.$router.push({
          name: "sign_up_path",
          query: {
            from: this.$route.path,
            join: "true",
            email: this.group.trainer?.email
          }
        });
        return;
      }

      this.isLoaded = true;

      const result = await this.$apollo.mutate<AddParticipantMutation, AddParticipantMutationVariables>({
        mutation: ADD_PARTICIPANT_MUTATION,
        variables: {
          groupId: this.$route.params.id || "",
          userEmail: currentUser.email,
          trainerEmail: this.getTrainerEmail()
        }
      });

      this.isLoaded = false;

      const id = result.data?.addParticipant?.id;

      if (!_.isEmpty(result.data?.addParticipant?.errors)) {
        await this.$alertService.addAlert({
          message: result.data?.addParticipant?.errors?.[0]?.message || "",
          type: "error"
        });
        return;
      }

      if (!id) {
        return;
      }

      this.group.participants.push({ email: currentUser.email, id, __typename: "User" });
      await this.$alertService.addAlert({
        message: "Thank you for signing up, please check your inbox to verify your email address.",
        type: "success"
      });

      await this.$router.push({ name: "success_path" });
    },
    async copyToClipboard() {
      this.$copyText(`${window.location.origin}${this.$route.path}`);
      await this.$alertService.addAlert({ message: "Link has been copied to your clipboard!", type: "success" });
    },
    getTrainerEmail() {
      return this.group.trainer?.email ? this.group.trainer?.email : (this.$route.query?.email as string);
    }
  }
});
